import { ElementRef, ViewChildren, QueryList, HostListener } from '@angular/core';  
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TradeDetails } from './trade-details/trade-details.component';
import { ResponseDrawerComponent } from './response-drawer/response-drawer.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Constant } from '../modules/shared/constants';
import { Utils } from '../modules/shared/utils';
import * as fromModels from '../modules/models/common-model';
import { ColumnDef } from '../modules/models/common-model';
import { SupervisionRow, SupervisionReviewRequest, ColorSelection } from '../modules/models/supervision-model';
import { FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { OnDestroy } from '@angular/core';
import { UserDetail, UserService } from '../modules/shared/user.service';
import * as fromEnums from '../modules/shared/common-enums';
import { SupervisionService } from '../modules/services/supervision';
import { ExcelExportService } from '../modules/shared/excel-export.service';
import { CommonDetailsService } from '../modules/shared/common-details.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ColumnFilterDialogComponent,
  ColumnFilterDialogData,
  ColumnFilterDialogResult,
  ColumnFilterValue,
  ColumnDataType,
  ColorSelectOption
} from '../modules/shared/column-filter-dialog/column-filter-dialog.component';

@Component({
  selector: 'app-supervision-report',
  templateUrl: './supervision-report.html',
  standalone: false,
  styleUrls: ['./supervision-report.scss']
})
export class SupervisionReport implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns: ColumnDef[] = [];
  visibleDisplayedColumns: ColumnDef[] = [];
  selection = new SelectionModel<SupervisionRow>(true, []);
  
  get displayedColumnNames(): string[] {
    return [...this.visibleDisplayedColumns.map(c => c.field), 'actions'];
  }

  isLastColumn(col: fromModels.ColumnDef): boolean {
    const cols = this.visibleDisplayedColumns;
    return cols.length > 0 && cols[cols.length - 1].field === col.field;
  }

  accountsDataSource = new MatTableDataSource<SupervisionRow>([]);
isInReportId = '';
facetReq = true;
  isTableLoading = false;
openedCardRow: any = null;
reportType='';
tradeDetailColumns: ColumnDef[] = [];
@ViewChildren('actionBar') actionBars!: QueryList<ElementRef>;
@ViewChild('activeActionBar', { static: false }) activeActionBar!: ElementRef;

  constructor(private dialog: MatDialog,
    private superVisionsvc: SupervisionService,
    private userSvc: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private excelSvc: ExcelExportService,
    private commonDetailsSvc: CommonDetailsService,
  ) {
    for(let i = this.selYear; i >= 2021; i--){
        this.years.push(i);
      }
      // Set latest year as default selected value
      if (this.years.length > 0) {
        this.selectedyear = this.years[0];
      }
      
      this.months = this.commonDetailsSvc.getMonthOptions('long', this.selectedyear);
  this.selectedMonth = new Date().getMonth() + 1;

    this.criteria.month = this.selectedMonth;
    this.criteria.year = this.selectedyear;
   }
  
pageSize: number = 0;
selectedMonth = 0;
selectedyear = 0;
criteria: fromModels.ISearchCriteria = { month: this.selectedMonth, year: this.selectedyear, pageNo: 1, pageSize: this.pageSize } as fromModels.ISearchCriteria;

orderByField = '';
orderBy = '';
filteredAccts: any[] = []; 
@ViewChild(MatPaginator, { static: false })
paginator!: MatPaginator;
totalCt: number = 0;  
rptTypes: fromModels.IKeyValue[] = [];
loggedInUser: UserDetail | undefined;
userSub!: Subscription;
repIdsSub!: Subscription;

filters: fromModels.IFieldQry[] = [];
facetFields: string[] = [];
isSelectedReportTradeBase = false;
tradeBaseFieldName = '';
isReportDialogModeNew = true;
showProgressSaveReport = false;
isGlobalReport = false;
isTemplateReport = false;
isComplianceReport = false;
_issuper = false;
showProgressChart = false;
_histoData: number[] = [];
_histoField = "";
_histoCategory: string[] = [];
showProgressSaveActVisibility = false;
selectedReportType = '';
daysRemainToRespond = 0;
_ctOpen = 0;
_ctClosed = 0;
_ctDeferred = 0;
ct = 0;
years:number[] = [];
selYear = new Date().getFullYear();

months: { value: number; label: string; }[] = [];
columnFilters: Map<string, ColumnFilterValue> = new Map();
activeFilterChips: { field: string; label: string }[] = [];
private allAccounts: any[] = [];
private rawL1Columns: fromModels.displayColumn[] = [];
private rawL2Columns: fromModels.displayColumn[] = [];
private colorSelections: ColorSelection[] = [];
private navAlertDescription: string | null = null;

  ngOnInit(): void {
    const navState = history.state as { rptType?: string; year?: number; month?: number; alertDescription?: string; reportRole?: string; reportTypes?: fromModels.IKeyValue[] };
    const queryReportType = (this.activatedRoute.snapshot.queryParamMap.get('reportType') || '').trim();

    if (queryReportType) {
      this.reportType = queryReportType;
      this.criteria.reportType = queryReportType;
      this.selectedReportType = queryReportType;
    } else if (navState?.rptType) {
      this.reportType = navState.rptType;
      this.criteria.reportType = navState.rptType;
      this.selectedReportType = navState.rptType;
    }

    if (typeof navState?.year === 'number' && !isNaN(navState.year)) {
      this.selectedyear = navState.year;
      this.criteria.year = navState.year;
    }

    if (typeof navState?.month === 'number' && !isNaN(navState.month)) {
      this.selectedMonth = navState.month;
      this.criteria.month = navState.month;
    }

    if (navState?.alertDescription) {
      this.navAlertDescription = navState.alertDescription;
    }

    if (navState?.reportRole) {
      this.criteria.reportRole = navState.reportRole;
    }

    if (navState?.reportTypes && navState.reportTypes.length > 0) {
      const seen = new Set<string>();
      this.rptTypes = navState.reportTypes.filter(rt => {
        const key = (rt?.key || '').trim();
        if (!key || seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    }

    this.superVisionsvc.getColorSelection().subscribe(data => {
      this.colorSelections = data || [];
      if (this.navAlertDescription) {
        this.syncNavDescToStatusFilter();
        if (this.allAccounts.length > 0) {
          this.applyClientSideFilters();
        }
      }
    });

    // Capture any repIds already set (e.g. navigating from Summary with advisors selected)
    this.criteria.repIds = this.userSvc.repIds$.getValue();

    this.userSub = this.userSvc.userSubject.subscribe(d => {
      if (d) {
        this.loggedInUser = d;
         if (this.loggedInUser?.role === fromEnums.USERROLE.SUPER 
           || this.loggedInUser?.role === fromEnums.USERROLE.COMP) {
          this._issuper = true;
         }
        this.getData();
      }
    });

    // skip(1) skips the BehaviorSubject's initial replay; only react to actual filter changes
    this.repIdsSub = this.userSvc.repIds$.pipe(skip(1)).subscribe(repIds => {
      this.criteria.repIds = repIds;
      this.getData();
    });
  }

 getDataOnSelection(){
    this.resetTableStateForSelectionChange();
    this.navAlertDescription = null;
    this.months = this.commonDetailsSvc.getMonthOptions('long', this.selectedyear);
    if (this.selectedMonth > this.months.length) {
      this.selectedMonth = this.months.length;
    }
    this.criteria.month = this.selectedMonth;
    this.criteria.year = this.selectedyear;
    this.criteria.reportType = this.selectedReportType;
    this.criteria.pageNo = 1;
    this.reportType = this.selectedReportType;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { reportType: this.selectedReportType || null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getData();
  }

  private resetTableStateForSelectionChange(): void {
    this.columnFilters.clear();
    this.orderByField = '';
    this.orderBy = '';
    this.openedCardRow = null;
  }

  ngAfterViewInit(): void {
    this.accountsDataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    if (this.repIdsSub) {
      this.repIdsSub.unsubscribe();
    }
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

goBack() {
    this.router.navigate(['/home']);
  }

    private getData() {

    this.isTableLoading = true;

    this.criteria.isSuperUser = this._issuper;
    this.criteria.query = this.filters;
    this.criteria.reportType = this.reportType;
    // Report grid columns come from the backend keyed by role, so always send the effective role.
    this.criteria.reportRole = this.loggedInUser?.role || this.criteria.reportRole || '';

    // If navigated with an alertDescription filter, add it as a server-side filter
    // so all matching records are returned (not just the current page subset).
    const baseFilters = [...this.filters];
    if (this.navAlertDescription) {
      baseFilters.push({
        name: 'alertDescription',
        dbName: 'alertDescription',
        op: fromEnums.OPERATOR.EQ,
        incBlank: false,
        numValues: [],
        strValues: [this.navAlertDescription],
        filtertype: fromEnums.FILTER_TYPE.TXT
      });
    }
    const requestPayload: fromModels.ISearchCriteriaRequest = {
      ...this.criteria,
      isSuperUser: this._issuper,
      query: baseFilters,
      reportType: this.reportType,
      reportRole: this.loggedInUser?.role || this.criteria.reportRole || ''
    };

    if (this.orderByField) {
      requestPayload.orderBy = this.orderByField;
      requestPayload.orderByDirection = this.orderBy ? this.orderBy : 'DESC';
    }

    this.superVisionsvc.getSupervisionData(requestPayload).subscribe(d => {      
      this._ctClosed = 0;
      this._ctDeferred = 0;
      this._ctOpen = 0;
      if (d && d.acctsummary && Array.isArray(d.acctsummary)) {
        this.allAccounts = d.acctsummary;
        this.accountsDataSource.data = d.acctsummary;
        this.filteredAccts = d.acctsummary;
        this.totalCt = d.totct ?? d.acctsummary.length;
        if (this.paginator) {
          this.accountsDataSource.paginator = this.paginator;
        }
        if (this.columnFilters.size > 0) {
          this.applyClientSideFilters();
        }
      } else {
        this.totalCt = 0;
        this.allAccounts = [];
        this.filteredAccts = [];
        this.accountsDataSource.data = [];
      }
      if(d.displayColumns){
        const filtered = d.displayColumns.filter(c => c.reportType == this.criteria.reportType && c.level == 'L1' && c.includeInUI == 'Y');
        this.rawL1Columns = [...filtered].sort((a, b) => (a.columnOrder ?? 0) - (b.columnOrder ?? 0));
        this.displayedColumns = this.mergeDisplayColumns(filtered);
        this.updateVisibleDisplayedColumns();

        if (this.rptTypes.length === 0) {
          this.rptTypes = d.displayColumns
            .filter((rpt, i, arr) => rpt.reportType && arr.findIndex(r => r.reportType === rpt.reportType) === i)
            .map(rpt => ({ key: rpt.reportType, value: rpt.reportName } as fromModels.IKeyValue));
        }

        const filteredL2 = d.displayColumns.filter(c => c.reportType == this.criteria.reportType && c.level == 'L2' && c.includeInUI == 'Y');
        this.rawL2Columns = [...filteredL2].sort((a, b) => (a.columnOrder ?? 0) - (b.columnOrder ?? 0));
        this.tradeDetailColumns = this.mergeDisplayColumns(filteredL2);
      } else {
        this.rawL1Columns = [];
        this.rawL2Columns = [];
        this.displayedColumns = [];
        this.visibleDisplayedColumns = [];
      }

      this.facetReq = false;
      this.isTableLoading = false;
    }, err => {
      this.facetReq = false;
      this.isTableLoading = false;
      this.userSvc.traceMsg('Error getting supervision data.', err, "Error");

    });
  }

private mergeDisplayColumns(
    columns: fromModels.displayColumn[],
  ): fromModels.ColumnDef[] {

    const sorted = [...columns].sort((a, b) => (a.columnOrder ?? 0) - (b.columnOrder ?? 0));
    const merged: fromModels.ColumnDef[] = [];
    const sameHeader: { [key: string]: { index: number, count: number } } = {};
    for (const c of sorted) {
      const key = (c.uiDisplayName || '').toLowerCase();
      const alias = c.indexAliasName || c.columnName;
      if (key in sameHeader) {
        const entry = sameHeader[key];
        entry.count++;
        if (entry.count === 2) {
          merged[entry.index].subField = alias;
          merged[entry.index].subFieldUiDataType = c.uiDataType;
        } else if (entry.count === 3) {
          merged[entry.index].parenthField = merged[entry.index].subField;
          merged[entry.index].subField = alias;
          merged[entry.index].subFieldUiDataType = c.uiDataType;
        }
      } else {
        sameHeader[key] = { index: merged.length, count: 1 };
        merged.push({
          columnName: alias,
          headerName: c.uiDisplayName,
          field: alias,
          uiDataType: c.uiDataType
        });
      }
    }
    return merged;
  }

  formatValue(value: any, col: fromModels.ColumnDef): string {
    return this.commonDetailsSvc.formatValue(value, col);
  }

  getRowColor(row: any): string {
    return row.fidAlertColor || row.fidalertcolor || row.FidAlertColor || row.FIDALERTCOLOR || '';
  }

  getRowAlertDescription(row: any): string {
    return row.alertDescription || row.alertdescription || row.AlertDescription || row.ALERTDESCRIPTION || '';
  }

  isRowOpen(row: any): boolean {
    return (row.status || '').toString().toUpperCase() === 'OPEN';
  }

  isRowDeferred(row: any): boolean {
    return (row.status || '').toString().toUpperCase() === 'DEFERRED';
  }

  getRowDeferredDate(row: any): string {
    const raw = row.deferredExpirationDate || row.deferredexpirationdate || row.DeferredExpirationDate || '';
    if (!raw) return '';
    const datePart = typeof raw === 'string' && raw.length >= 10 ? raw.substring(0, 10) : raw;
    const d = new Date(datePart + 'T00:00:00');
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }

  formatSubFieldValue(value: any, col: fromModels.ColumnDef): string {
    return this.commonDetailsSvc.formatByDataType(value, col.subFieldUiDataType);
  }

  isTimestamp(col: fromModels.ColumnDef): boolean {
    return (col.subFieldUiDataType || '').toLowerCase() === 'timestamp';
  }

  getAlignment(col: fromModels.ColumnDef): string {
    return this.commonDetailsSvc.getAlignment(col, this.filteredAccts);
  }

  shouldWrap(col: fromModels.ColumnDef): boolean {
    return this.commonDetailsSvc.shouldWrap(col);
  }

  openCard(row: any) {
    if (this.openedCardRow === row) {
      this.openedCardRow = null;
    } else {
      this.openedCardRow = row;
    }
  }
    
  closeCard() {
    this.openedCardRow = null;
  }
  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.openedCardRow) return;
    let clickedInside = false;
    // Check if click is inside the currently open action-bar
    if (this.activeActionBar && this.activeActionBar.nativeElement.contains(event.target)) {
      clickedInside = true;
    }
    // Fallback: check all action bars (for safety)
    this.actionBars?.forEach(ref => {
      if (ref.nativeElement.contains(event.target)) {
        clickedInside = true;
      }
    });
    if (!clickedInside) {
      this.closeCard();
    }
  }
    openAccountActivity(row: any, event: Event) {
    event.stopPropagation();
    const currentReportType = (this.selectedReportType || this.reportType || '').toUpperCase();
    const tradeBy = row.accountNumber || row.account_number || '';
    const client = row.ClientName || row.clientName || row.CLIENTNAME || row.client_name || '';
    const partyId = row.partyID || row.partyId || row.party_id || '';
    const partyType = row.partyType || row.party_type || '';
    const partyDetails = partyId
      ? [{ partyId, partyType, clientName: client }]
      : [];
      this.dialog.open(TradeDetails, {
      width: '1600px',
      height: '100vh',
      position: { right: '0', top: '0' },
      data: { row: row, displayedColumns: this.tradeDetailColumns, accountNumber: tradeBy, clientName:client, partyDetails, reportType: this.rptTypes.find(r => r.key === this.selectedReportType)?.value || currentReportType, reportTypeValue: currentReportType },
      panelClass: 'side-panel-dialog'
    });
  }

  openResponseDrawer(row: any, event: Event): void {
    event.stopPropagation();
    console.log('Opening response drawer for row:', row.departmentId);
    const currentReportType = this.selectedReportType || this.reportType || '';
    const isSUR = currentReportType.toUpperCase() === 'SUR'; //Surrender report uses DepartmentId
    const isDMA = currentReportType.toUpperCase() === 'DMA'; //DMA reports use party ID
    const isBrokerageConc = currentReportType.toUpperCase() === 'CON'; // brokerage concentration report uses party ID
    const isEPY = currentReportType.toUpperCase() === 'EPY'; // equifax uses party ID
    const tradeBy = isSUR
      ? (row.departmentId || '')
      : (isDMA || isBrokerageConc || isEPY)
        ? (row.partyID || '')
        : (row.accountNumber || row.account_number || row.clientName || row.client_name || row.departmentId || ''); // todo: remove other or conditions other than account number
    const displayTradeBy = (isSUR || isDMA || isBrokerageConc || isEPY) ? '' : tradeBy;
    const reportTypeLabel = this.rptTypes.find(r => r.key === this.selectedReportType)?.value || this.selectedReportType || this.reportType || '';
    const reportTypeValue = currentReportType;
    const monthLabel = this.months.find(m => m.value === this.selectedMonth)?.label || '';

    const request: SupervisionReviewRequest = {
      reviewId: 0,
      attestationId: '',//row.attestationID ||
      reportType: currentReportType,
      reportMonth: 0,//this.selectedMonth,
      reportYear: 0,//this.selectedyear,
      referenceId: tradeBy || '',
      getStatusOnly: 'N'
    };

    this.superVisionsvc.getSupervisionItems(request).subscribe({
      next: (items) => {
        this.openResponseDialog({
          row,
          accountNumber: displayTradeBy,
          referenceId: tradeBy,
          reportType: reportTypeLabel,
          reportTypeValue: reportTypeValue,
          month: monthLabel,
          reportMonth: this.selectedMonth,
          reportYear: this.selectedyear,
          supervisionItems: items || [],
          status: row.status ?? ''
        }, '1400px');
      },
      error: () => {
        this.openResponseDialog({
          row,
          accountNumber: displayTradeBy,
          referenceId: tradeBy,
          reportType: reportTypeLabel,
          reportTypeValue: reportTypeValue,
          month: monthLabel,
          reportMonth: this.selectedMonth,
          reportYear: this.selectedyear,
          supervisionItems: []
        }, '1200px');
      }
    });
  }

  private openResponseDialog(data: any, width: string): void {
    // Open on next tick so child initialization does not mutate bindings in the same click check cycle.
    setTimeout(() => {
      const ref = this.dialog.open(ResponseDrawerComponent, {
        width,
        height: '100vh',
        position: { right: '0', top: '0' },
        data,
        panelClass: 'side-panel-dialog',
        autoFocus: false,
        restoreFocus: false
      });
      ref.afterOpened().subscribe(() => {
        setTimeout(() => ref.componentInstance?.resetResponseLogScroll(), 0);
      });
      ref.afterClosed().subscribe(() => {
        this.getData();
      });
    }, 0);
  }

  // --- Column filter dialog ---

  openColumnFilter(event: MouseEvent, col: fromModels.ColumnDef): void {
    event.stopPropagation();
    const dataType = this.commonDetailsSvc.getColumnDataType(col.uiDataType);
    const isStatusCol = col.field === 'status';
    const useSelect = !isStatusCol && dataType === 'text' && this.getDistinctValues(col.field).length <= 30;
    const effectiveType: ColumnDataType = isStatusCol ? 'color-select' : (useSelect ? 'select' : dataType);

    const dialogData: ColumnFilterDialogData = {
      columnName: col.headerName,
      field: col.field,
      dataType: effectiveType,
      selectOptions: effectiveType === 'select' ? this.getDistinctValues(col.field) : undefined,
      colorSelectOptions: isStatusCol ? this.getStatusColorOptions() : undefined,
      currentSort: this.orderByField === col.field ? (this.orderBy as 'A' | 'D') : '',
      currentFilter: this.columnFilters.get(col.field),
      showSort: !isStatusCol
    };

    let target = event.target as HTMLElement;
    while (target && !target.classList.contains('filter-icon') && target.parentElement) {
      target = target.parentElement;
    }
    const rect = target.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const gap = 2;
    const margin = 12;
    const dialogWidth = 220;

    const iconCenterX = rect.left + rect.width / 2;
    let leftPx = Math.max(margin, iconCenterX - 40);
    if (leftPx + dialogWidth > viewportWidth - margin) {
      leftPx = viewportWidth - dialogWidth - margin;
    }
    if (leftPx < margin) leftPx = margin;

    const arrowLeftPx = Math.max(12, Math.min(iconCenterX - leftPx - 12, dialogWidth - 36));

    const spaceBelow = viewportHeight - rect.bottom - gap - margin;
    const spaceAbove = rect.top - gap - margin;
    let arrowDirection: 'up' | 'down' = 'up';
    if (spaceBelow < 300 && spaceAbove > spaceBelow) {
      arrowDirection = 'down';
    }
    const topPx = arrowDirection === 'down'
      ? Math.max(margin, rect.top - gap - 300)
      : rect.bottom + gap;

    const dialogRef = this.dialog.open(ColumnFilterDialogComponent, {
      width: dialogWidth + 'px',
      maxHeight: (viewportHeight - margin * 2 - gap) + 'px',
      data: dialogData,
      autoFocus: false,
      panelClass: arrowDirection === 'down'
        ? ['column-filter-panel', 'column-filter-panel-flip']
        : 'column-filter-panel',
      position: { top: topPx + 'px', left: leftPx + 'px' },
      hasBackdrop: true,
      backdropClass: 'transparent-backdrop'
    });

    dialogRef.afterOpened().subscribe(() => {
      const pane = document.querySelector('.column-filter-panel') as HTMLElement;
      if (!pane) return;
      const arrow = document.createElement('div');
      arrow.style.marginLeft = arrowLeftPx + 'px';
      arrow.className = arrowDirection === 'up' ? 'filter-arrow-up' : 'filter-arrow-down';
      pane.insertBefore(arrow, pane.firstChild);

      requestAnimationFrame(() => {
        const actualHeight = pane.getBoundingClientRect().height;
        let adjustedTop: number;
        if (arrowDirection === 'down') {
          adjustedTop = rect.top - gap - actualHeight;
          if (adjustedTop < margin) adjustedTop = margin;
        } else {
          adjustedTop = rect.bottom + gap;
          if (adjustedTop + actualHeight > viewportHeight - margin) {
            const aboveTop = rect.top - gap - actualHeight;
            if (aboveTop >= margin) {
              adjustedTop = aboveTop;
              pane.classList.add('column-filter-panel-flip');
              arrow.className = 'filter-arrow-down';
            } else {
              adjustedTop = Math.max(margin, viewportHeight - actualHeight - margin);
            }
          }
        }
        pane.style.marginTop = adjustedTop + 'px';
        requestAnimationFrame(() => pane.classList.add('column-filter-ready'));
      });
    });

    dialogRef.afterClosed().subscribe((result: ColumnFilterDialogResult) => {
      if (!result) return;
      // User took manual control of Status filter — release the nav description lock
      if (col.field === 'status') {
        this.navAlertDescription = null;
      }
      if (result.cleared) {
        this.columnFilters.delete(col.field);
        if (this.orderByField === col.field) {
          this.orderByField = '';
          this.orderBy = '';
        }
      } else {
        if (result.sort) {
          this.orderByField = col.field;
          this.orderBy = result.sort;
        }
        if (result.filter) {
          const hasValue = result.filter.textValue ||
            (result.filter.selectValues && result.filter.selectValues.length > 0) ||
            result.filter.datePreset ||
            result.filter.numberFilterMode;
          if (hasValue) {
            this.columnFilters.set(col.field, result.filter);
          } else {
            this.columnFilters.delete(col.field);
          }
        }
      }
      this.updateFilterChips();
      this.applyClientSideFilters();
    });
  }

  hasColumnFilter(field: string): boolean {
    return this.columnFilters.has(field);
  }

  private updateFilterChips(): void {
    const chips: { field: string; label: string }[] = [];
    this.columnFilters.forEach((filterVal, field) => {
      const col = this.displayedColumns.find(c => c.field === field);
      const headerName = col?.headerName || field;
      let summary = '';
      if (filterVal.selectValues?.length) {
        summary = filterVal.selectValues.join(', ');
      } else if (filterVal.textValue) {
        summary = filterVal.textValue;
      } else if (filterVal.datePreset) {
        if (filterVal.datePreset === 'today') summary = 'Today';
        else if (filterVal.datePreset === 'last7') summary = 'Last 7 days';
        else if (filterVal.dateFrom || filterVal.dateTo) {
          const from = filterVal.dateFrom ? new Date(filterVal.dateFrom).toLocaleDateString() : '';
          const to = filterVal.dateTo ? new Date(filterVal.dateTo).toLocaleDateString() : '';
          summary = from && to ? `${from} - ${to}` : from || to;
        }
      } else if (filterVal.numberFilterMode) {
        if (filterVal.numberFilterMode === 'between') {
          summary = `${filterVal.numberMin ?? ''} - ${filterVal.numberMax ?? ''}`;
        } else {
          summary = `${filterVal.numberFilterMode} ${filterVal.numberValue ?? ''}`;
        }
      }
      chips.push({ field, label: summary ? `${headerName}: ${summary}` : headerName });
    });
    this.activeFilterChips = chips;
  }

  removeFilter(field: string): void {
    this.columnFilters.delete(field);
    if (field === 'status') {
      this.navAlertDescription = null;
    }
    this.updateFilterChips();
    this.applyClientSideFilters();
  }

  getDistinctValues(field: string): string[] {
    const values = new Set<string>();
    (this.allAccounts || []).forEach(item => {
      const val = item[field];
      if (val != null && val !== '') values.add(String(val));
    });
    return Array.from(values).sort();
  }

  private syncNavDescToStatusFilter(): void {
    const desc = (this.navAlertDescription || '').toLowerCase();
    const rptType = (this.criteria.reportType || '').toLowerCase();
    const match = this.colorSelections.find(cs =>
      (!rptType || (cs.groupCode || '').toLowerCase() === rptType) &&
      (cs.alertDescription || '').toLowerCase() === desc
    );
    if (match?.alertCategory) {
      this.columnFilters.set('status', { selectValues: [Utils.titleCase(match.alertCategory)] });
      this.updateFilterChips();
    }
  }

  private getStatusColorOptions(): ColorSelectOption[] {
    const seen = new Set<string>();
    const options: ColorSelectOption[] = [];
    for (const cs of this.colorSelections) {
      const matchesRptType = !this.criteria.reportType || (cs.groupCode || '').toLowerCase() === this.criteria.reportType.toLowerCase();
      if (!matchesRptType) continue;
      const label = cs.alertCategory;
      const color = cs.fidAlertColor;
      if (label && color && !seen.has(label.toLowerCase())) {
        seen.add(label.toLowerCase());
        options.push({ label: Utils.titleCase(label), color });
      }
    }
    return options;
  }


  private updateVisibleDisplayedColumns(): void {
    if (!this.displayedColumns.length) {
      this.visibleDisplayedColumns = [];
      return;
    }

    // Keep all configured columns visible, even when a column has no values in current rows.
    this.visibleDisplayedColumns = [...this.displayedColumns];

    const visibleFields = new Set(this.visibleDisplayedColumns.map(c => c.field));

    for (const field of Array.from(this.columnFilters.keys())) {
      if (!visibleFields.has(field)) {
        this.columnFilters.delete(field);
      }
    }
    this.updateFilterChips();

    if (this.orderByField && !visibleFields.has(this.orderByField)) {
      this.orderByField = '';
      this.orderBy = '';
    }
  }

  private applyClientSideFilters(): void {
    if (!this.allAccounts || !this.allAccounts.length) {
      this.accountsDataSource.data = [];
      this.filteredAccts = [];
      return;
    }

    let filtered = this.allAccounts;

    if (this.columnFilters.size > 0) {
      // Separate status color filter from other filters
      const statusFilter = this.columnFilters.get('status');
      const otherFilters = new Map(this.columnFilters);
      otherFilters.delete('status');

      if (otherFilters.size > 0) {
        filtered = filtered.filter(item => this.commonDetailsSvc.matchesColumnFilters(item, otherFilters));
      }

      // Apply status color filter by fidAlertColor, scoped to current reportType via groupCode
      if (statusFilter && statusFilter.selectValues && statusFilter.selectValues.length > 0) {
        const selectedLabels = new Set(statusFilter.selectValues.map(v => v.toLowerCase()));
        const allowedColors = new Set<string>();
        this.colorSelections.forEach(cs => {
          const matchesRptType = !this.criteria.reportType || (cs.groupCode || '').toLowerCase() === this.criteria.reportType.toLowerCase();
          if (matchesRptType && cs.alertCategory && selectedLabels.has(cs.alertCategory.toLowerCase())) {
            allowedColors.add(cs.fidAlertColor.toLowerCase());
          }
        });
        filtered = filtered.filter(row => {
          const rowColor = (row.fidAlertColor || row.fidalertcolor || '').toLowerCase();
          return allowedColors.has(rowColor);
        });
      }
    }

    // Apply nav alertDescription filter — match directly on the row's alertDescription field
    if (this.navAlertDescription) {
      const navDesc = this.navAlertDescription.toLowerCase();
      filtered = filtered.filter(row => {
        const rowDesc = (row.alertDescription || (row as any).alertdescription || '').toLowerCase();
        return rowDesc === navDesc;
      });
    }

    // Sort
    if (this.orderByField) {
      const direction = this.orderBy === 'A' ? 1 : -1;
      const sortField = this.orderByField;
      const col = this.visibleDisplayedColumns.find(c => c.field === sortField) || this.displayedColumns.find(c => c.field === sortField);
      const colType = this.commonDetailsSvc.getColumnDataType(col?.uiDataType);
      filtered = [...filtered].sort((a, b) => {
        const aVal = a[sortField];
        const bVal = b[sortField];
        return this.commonDetailsSvc.compareValues(aVal, bVal, colType) * direction;
      });
    }

    this.accountsDataSource.data = filtered;
    this.filteredAccts = filtered;
    if (this.paginator) {
      this.paginator.firstPage();
      this.accountsDataSource.paginator = this.paginator;
    }
  }

exportToExcel() {
    if (!this.filteredAccts.length) return;

    // Build headers using raw columns: uiDisplayName(indexAliasName) for duplicates
    const buildExcelHeaders = (columns: fromModels.displayColumn[]) => {
      const nameCounts: { [key: string]: number } = {};
      columns.forEach(c => {
        const key = (c.uiDisplayName || '').toLowerCase();
        nameCounts[key] = (nameCounts[key] || 0) + 1;
      });
      return columns.map(c => {
        const key = (c.uiDisplayName || '').toLowerCase();
        const alias = c.indexAliasName || c.columnName;
        return nameCounts[key] > 1 ? `${c.uiDisplayName}(${alias})` : c.uiDisplayName;
      });
    };

    const l1Headers = buildExcelHeaders(this.rawL1Columns);
    const l2Headers = buildExcelHeaders(this.rawL2Columns);
    const headers = [...l1Headers, ...l2Headers];

    const data: any[][] = [];

    this.filteredAccts.forEach(row => {
      const l1Values = this.rawL1Columns.map(c => {
        const field = c.indexAliasName || c.columnName;
        const val = row[field];
        return this.commonDetailsSvc.formatByDataType(val, c.uiDataType) || (val ?? '');
      });

      const trades: any[] = row.tradeDetails || [];
      if (trades.length > 0) {
        trades.forEach(trade => {
          const l2Values = this.rawL2Columns.map(c => {
            const field = c.indexAliasName || c.columnName;
            const val = trade[field];
            return this.commonDetailsSvc.formatByDataType(val, c.uiDataType) || (val ?? '');
          });
          data.push([...l1Values, ...l2Values]);
        });
      } else {
        const emptyL2 = this.rawL2Columns.map(() => '');
        data.push([...l1Values, ...emptyL2]);
      }
    });

    const reportTypeKey = this.selectedReportType || this.reportType;
    const reportTypeLabel = this.rptTypes.find(r => r.key === reportTypeKey)?.value || reportTypeKey;
    this.excelSvc.generateExcel(headers, data, this.selectedMonth, this.selectedyear, reportTypeLabel);
  }
}
